export const commonEnTranslations = {
  fullPageShell: {
    progressAriaLabel: 'Step {{step}} of {{total}}',
  },

  // Common
  language: 'Language',
  selectYourPreferredLanguage: 'Select your preferred language',
  today: 'Today',
  yesterday: 'Yesterday',
  anotherDate: 'Another date',
  clear: 'Clear',
  close: 'Close',
  enter: 'Enter',

  // Pages
  myInteractions: 'My Interactions',
  myInteractionsDescription:
    'View and manage all your I See You, I Need You, and I Learn interactions',
  indexRoute: 'Index Route',
  youAreSignedIn: 'You are signed in',
  youAreSignedOut: 'You are signed out',
  errorLoadingData: 'Error loading employees or goals or company values:',
  errorLoadingEmployees: 'Error loading employees:',
  loadingData: 'Loading employees, goals, and company values...',
  loadingDebrief: 'Loading debrief...',
  loadingFeedback: 'Loading feedback...',
  loadingPraise: 'Loading praise...',
  notFound: (type: string) => `${type} not found`,
  goBack: 'Go back',
  backToInteractions: 'Back to Interactions',
  selected: 'Selected:',
  usageExamples: 'Usage Examples',
  chooseListDemo: 'Choose List Input Component Demo',

  // Date picker
  selectDate: 'Select a date',
  pickDate: 'Pick a date',
  pickDateRange: 'Pick a date range',
  shortFormat: 'Short format',
  shortDateFormat: 'Short date format',
  selectedDate: 'Selected date',

  // Choose list
  chooseOption: 'Choose an option',
  selectOption: 'Select one of the available options below',
  selectedOption: 'Selected option',

  // Demo page
  componentDemos: 'Component Demos',
  componentDemosDescription:
    'Interactive demonstrations of our input components',
  datePickerInput: 'Date Picker Input',
  datePickerDescription: 'Choose any date from the calendar',
  chooseListInput: 'Choose List Input',
  chooseListDescription: 'Select one of the available options below',

  // Options
  option1: 'Option 1',
  option1Description: 'First option with description',
  option2: 'Option 2',
  option2Description: 'Second option with description',
  option3: 'Option 3',
  option3Description: 'Third option with description',
  option4: 'Option 4',
  option4Description: 'Fourth option with description',
  option5: 'Option 5',

  // Interaction type selection
  selectInteractionType: 'Select Interaction Type',
  selectInteractionTypeDescription:
    'Choose whether you want to send praise or feedback',
  sendInteractionTo: 'Send interaction to',
  chooseInteractionType: 'Choose how you want to interact',
  chooseHowToInteractWith: 'Choose how you want to interact with',
  option5Description: 'Fifth option with description',

  // Employee Roles - maps Role enum values to display names
  employeeRoles: {
    systemAdmin: 'System Admin',
    admin: 'Admin',
    manager: 'Manager',
    employee: 'Employee',
  },

  // Platform Restriction
  platformRestriction: {
    desktopOnly: 'This feature is only available on desktop',
    mobileOnly: 'This feature is only available on mobile',
    switchTo: 'Please switch to {{platform}} to access this feature',
    returnHome: 'Return to Home',
  },

  // Dashboard
  dashboard: 'Dashboard',
  currentMonth: 'Current Month',
  quickActions: 'Quick Actions',
  createFeedback: 'I Need You',
  createFeedbackDescription: 'Share constructive feedback',
  createPraise: 'I See You',
  createPraiseDescription: 'Recognize great work',
  createDebrief: 'I Learn',
  createDebriefDescription: 'Schedule team debrief',
  praiseReview: 'Praise Review',
  feedbackReview: 'Feedback Review',

  // Pending Feedback
  pendingFeedback: 'Pending Feedback',
  noPendingFeedback: 'No pending feedback items',
  activeDuration: 'Active Duration',
  actions: 'Actions',
  creator: 'Owner',
  receiver: 'Receiver',
  loading: 'Loading',
  error: 'Error',
  day: 'day',
  days: 'days',

  // Open Blockages
  openBlockages: 'Open Blockages',
  blockagesReceived: 'Blockages you received',
  blockageReceived: 'Blockage received',
  noBlockages: 'No open blockages',
  noOpenBlockages: 'No Open Blockages',
  allClear: 'All clear! You have no pending blockages.',
  viewAllBlockages: 'View all blockages',
  reviewBlockages: 'Review Blockages',
  requiresAttention: 'Requires Attention',

  // Intera Tasks
  actionPlans: 'INTERA Tasks',
  taskName: 'Task Name',
  dueDate: 'Due Date',
  linkedInteraction: 'Related Interaction',
  noActionPlans: 'No INTERA tasks',
  takeAction: 'Take Action',
  dueSoon: 'Task due this week',
  overdue: 'Task overdue',

  // Dashboard Header
  welcomeBack: (name: string) => `Welcome back, ${name}`,
  dashboardSubtitle: "Here's what's happening with your team",

  // Navigation
  signOut: 'Sign Out',
  home: 'Home',
  iSeeYou: 'I See You',
  iNeedYou: 'I Need You',
  iLearn: 'I Learn',
  goals: 'Goals',
  knowledge: 'Knowledge',
  dealIntelligence: 'Deal Intelligence',
  kci: 'KCI',
  kciRadar: 'KCI Radar',
  interactions: 'Interactions',
  oneOnOne: '1:1',
  profile: 'Profile',
  employeeHierarchy: 'Employee Hierarchy',

  // Employee Hierarchy page
  employeeHierarchyPageTitle: 'Employee Hierarchy',
  employeeHierarchyCompany: 'Company',
  employeeHierarchySelectCompany: 'Select a company',
  employeeHierarchySelectCompanyHint:
    'Select a company to view its employee hierarchy.',
  employeeHierarchyLoading: 'Loading hierarchy...',
  employeeHierarchyNoEmployees: 'No employees found for this company.',
  employeeHierarchyRoleSystemAdmin: 'System Admin',
  employeeHierarchyRoleAdmin: 'Admin',
  employeeHierarchyRoleManager: 'Manager',
  employeeHierarchyRoleEmployee: 'Employee',

  // Latest Interactions
  loadingInteractions: 'Loading interactions...',
  noInteractionsFound: 'No interactions found',

  // Open Blockages Banner
  oneOpenBlockage: '1 Open Blockage',
  multipleOpenBlockages: (count: number) => `${count} Open Blockages`,
  openBlockagesDescription: 'Review and address these items',
  review: 'Review',
};
